/**
 * Search Overlay Handler
 * Provides modern overlay search experience when search icon is clicked
 */

(function() {
  'use strict';

  // Get DOM elements
  const searchOverlay = document.getElementById('search-overlay');
  const searchTrigger = document.querySelector('.search-overlay-trigger');
  const searchClose = document.querySelector('.search-overlay__close');
  const searchBackdrop = document.querySelector('.search-overlay__backdrop');
  const searchInput = searchOverlay?.querySelector('.search-form__input');

  // Exit if required elements don't exist
  if (!searchOverlay || !searchTrigger) {
    return;
  }

  /**
   * Opens the search overlay
   */
  function openOverlay() {
    searchOverlay.classList.add('is-active');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden'; // Prevent background scroll

    // Focus search input after animation completes
    setTimeout(() => {
      if (searchInput) {
        searchInput.focus();
      }
    }, 300);
  }

  /**
   * Closes the search overlay
   */
  function closeOverlay() {
    searchOverlay.classList.remove('is-active');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = ''; // Restore scroll

    // Return focus to trigger button
    searchTrigger.focus();
  }

  /**
   * Toggles the overlay state
   */
  function toggleOverlay(e) {
    e.preventDefault();

    if (searchOverlay.classList.contains('is-active')) {
      closeOverlay();
    } else {
      openOverlay();
    }
  }

  // Event: Toggle overlay on trigger button click
  searchTrigger.addEventListener('click', toggleOverlay);

  // Event: Close on close button click
  if (searchClose) {
    searchClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeOverlay();
    });
  }

  // Event: Close on backdrop click
  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', closeOverlay);
  }

  // Event: Close on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
      closeOverlay();
    }
  });

  // Event: Trap focus within overlay when open
  searchOverlay.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && searchOverlay.classList.contains('is-active')) {
      const focusableElements = searchOverlay.querySelectorAll(
        'input, button, [href], [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      // Shift+Tab on first element: focus last element
      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      }
      // Tab on last element: focus first element
      else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });

})();
